<script lang="ts">
import type * as L from 'leaflet'
import { InjectionKeys, Utilities, Functions } from '@vue-leaflet/vue-leaflet'
import 'leaflet.markercluster/dist/MarkerCluster.css'
import 'leaflet.markercluster/dist/MarkerCluster.Default.css'

const {
  AddLayerInjection,
  RemoveLayerInjection
} = InjectionKeys

const {
  remapEvents,
  propsBinder
} = Utilities

export default defineComponent({
  props: {
    options: { type: Object as PropType<L.MarkerClusterGroupOptions>, default: () => ({}) }
  },
  emits: ['ready'],
  setup(props, ctx) {
    const ready = shallowRef(false)
    const leafletObject = shallowRef<L.MarkerClusterGroup | null>(null)
    
    const addLayer = assertInject(AddLayerInjection)
    const removeLayer = assertInject(RemoveLayerInjection)

    provide(AddLayerInjection, (layer) => leafletObject.value?.addLayer(layer.leafletObject))

    provide(RemoveLayerInjection, (layer) => leafletObject.value?.removeLayer(layer.leafletObject))

    const { methods } = Functions.FeatureGroup.setupFeatureGroup(props, leafletObject, ctx)

    onMounted(async () => {
      const { MarkerClusterGroup } = await import('leaflet.markercluster')

      leafletObject.value = new MarkerClusterGroup({
        ...props.options,
        chunkedLoading: true
      })

      const { listeners } = remapEvents(ctx.attrs)
      leafletObject.value?.on(listeners)

      propsBinder(methods, leafletObject.value, props)

      addLayer({
        ...props,
        ...methods,
        leafletObject: leafletObject.value as L.MarkerClusterGroup,
      })

      ready.value = true
      nextTick(() => ctx.emit('ready', leafletObject.value))
    })

    onBeforeUnmount(() => leafletObject.value && removeLayer({ leafletObject: leafletObject.value }))

    return {
      ready,
      leafletObject
    }
  },
  render () {
    return Functions.Layer.render(this.ready, this.$slots)
  }
})
</script>
